import { roundToThree } from './roundToThree';
import { formatAndConvertToNumber } from './formatAndConvertToNumber';

export const openingCalculations = (opening) => {
    const { height, width, depth } = opening;

    const formattedHeight = formatAndConvertToNumber(height);
    const formattedWidth = formatAndConvertToNumber(width);
    const formattedDepth = formatAndConvertToNumber(depth);

    const area = roundToThree(Number(formattedHeight) * Number(formattedWidth));
    const perimeter = roundToThree(2 * (Number(formattedHeight) + Number(formattedWidth)));
    const slope_perimeter = roundToThree(2 * Number(formattedHeight) + Number(formattedWidth));
    const slope_area = roundToThree(
        formattedDepth * (2 * Number(formattedHeight) + Number(formattedWidth))
    );

    return { area, perimeter, slope_area, slope_perimeter };
};
